import { render, staticRenderFns } from "./company-component.vue?vue&type=template&id=69839f6e&lang=html"
import script from "./company-component.vue?vue&type=script&lang=js"
export * from "./company-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports